import { NgModule } from "@angular/core";
import { PagesGestioneAnagraficaCreaAnagraficaComponent } from "./crea-anagrafica/crea-anagrafica.component";
import { PagesGestioneAnagraficaRoutingModule } from "./gestione-anagrafica.routing";
import { PagesGestioneAnagraficaRicercaAnagraficaComponent } from "./ricerca-anagrafica/ricerca-anagrafica.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedToolkitModule } from "../../_shared/toolkit/toolkit.module";
import { CommonModule } from "@angular/common";
import { PagesGestioneAnagraficaToolkitModule } from "./_toolkit/toolkit-module";
import { PagesGestioneAnagraficaModificaAnagraficaComponent } from "./modifica-anagrafica/modifica-anagrafica.component";

@NgModule({
  declarations: [
    PagesGestioneAnagraficaCreaAnagraficaComponent,
    PagesGestioneAnagraficaRicercaAnagraficaComponent,
    PagesGestioneAnagraficaModificaAnagraficaComponent,
  ],
  exports: [
    PagesGestioneAnagraficaCreaAnagraficaComponent,
    PagesGestioneAnagraficaRicercaAnagraficaComponent,
    PagesGestioneAnagraficaModificaAnagraficaComponent,
  ],
  imports: [
    PagesGestioneAnagraficaRoutingModule,
    PagesGestioneAnagraficaToolkitModule,
    ReactiveFormsModule,
    NgbModule,
    SharedToolkitModule,
    CommonModule,
  ],
})
export class PagesGestioneAnagraficaModule {}
